import LegalShell from "./LegalShell";
import {
  LEGAL_CONTACT_EMAIL,
  LEGAL_LAST_UPDATED,
  SUPPORT_CONTACT_EMAIL,
} from "./legalMeta";

export default function RefundPolicyPage() {
  return (
    <LegalShell title="Refund Policy" date={LEGAL_LAST_UPDATED}>
      <div className="legal-callout">
        <p>
          <strong>Summary:</strong> Paid plans are billed in advance and are
          generally non-refundable once a billing period starts, except where
          required by law or specifically stated in this policy.
        </p>
      </div>

      <h2>1. Scope</h2>
      <p>
        This Refund Policy explains when refunds may be available for purchases
        made from Ateno Inc. (&quot;Ateno,&quot; &quot;we,&quot; &quot;us&quot;).
        It applies to subscriptions and other paid services purchased directly
        from Ateno.
      </p>

      <h2>2. Subscription Charges</h2>
      <p>
        Subscription fees are billed in advance on a monthly or annual cycle,
        depending on your selected plan. Unless otherwise stated, charges are
        non-refundable after the billing period begins.
      </p>

      <h2>3. Trial Periods</h2>
      <p>
        If a free trial is offered, no charge is applied until the trial ends.
        To avoid charges, cancel before the trial converts to a paid
        subscription.
      </p>

      <h2>4. Cancellation</h2>
      <p>
        You may cancel at any time. Cancellation stops future renewals, and
        your paid access continues through the end of the current billing
        period unless otherwise required by applicable law.
      </p>

      <h2>5. When Refunds May Be Granted</h2>
      <p>We may provide a full or partial refund in cases such as:</p>
      <ul>
        <li>duplicate charges caused by a billing error</li>
        <li>verified technical failures that prevented service access</li>
        <li>unauthorized transactions, after review</li>
        <li>other situations where refund rights apply under local law</li>
      </ul>

      <h2>6. Non-Refundable Items</h2>
      <p>Except where required by law, refunds are not provided for:</p>
      <ul>
        <li>partial billing periods after service has started</li>
        <li>unused time remaining on an active subscription term</li>
        <li>plan downgrades applied mid-cycle</li>
        <li>suspension or termination for Terms of Service violations</li>
      </ul>

      <h2>7. How to Request a Refund</h2>
      <p>
        To request a refund, contact us at{" "}
        <a href={`mailto:${SUPPORT_CONTACT_EMAIL}`}>{SUPPORT_CONTACT_EMAIL}</a>{" "}
        with your account email, order or invoice details, and a short
        description of the issue. We may request additional information to
        verify ownership and transaction history.
      </p>

      <h2>8. Processing Time</h2>
      <p>
        Eligible refunds are typically processed within 5 to 10 business days.
        Final posting times depend on your payment provider and financial
        institution.
      </p>

      <h2>9. Chargebacks</h2>
      <p>
        Before filing a chargeback, please contact us so we can resolve billing
        issues quickly. Fraudulent or abusive chargebacks may result in account
        restrictions.
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Refund Policy from time to time. Changes become
        effective when posted, and material updates may also be communicated
        through the Service.
      </p>

      <h2>11. Contact</h2>
      <div className="legal-callout">
        <p>
          Ateno Inc. · Billing &amp; Legal ·{" "}
          <a href={`mailto:${SUPPORT_CONTACT_EMAIL}`}>{SUPPORT_CONTACT_EMAIL}</a>{" "}
          · Legal: <a href={`mailto:${LEGAL_CONTACT_EMAIL}`}>{LEGAL_CONTACT_EMAIL}</a>
        </p>
      </div>
    </LegalShell>
  );
}
